if (!window.Eurus.loadedScript.includes('popup.js')) {
  window.Eurus.loadedScript.push('popup.js');
  
  // Register xPopups component immediately
  if (typeof Alpine !== 'undefined') {
    Alpine.data('xPopups', (data) => ({
      enable: false,
      showMinimal: false,
      show: Shopify.designMode ? ( localStorage.getItem(data.name + '-' + data.sectionId)? xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)) : true ) : false,
      delayDays: data.delayDays ? data.delayDays : 0,
      t: '',
      copySuccess: false,
      init() {
        if (Shopify.designMode) {
          var _this = this;
          const handlePopupSelect = (event, isResize = null) => {
            if (event.detail && event.detail.sectionId.includes(data.sectionId) || isResize) {
              if (window.Alpine) {
                _this.open();
                localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
              } else {
                document.addEventListener('alpine:initialized', () => {
                  _this.open();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
                });
              }
            } else {
              if (window.Alpine) {
                _this.closeSection();
                localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
              } else {
                document.addEventListener('alpine:initialized', () => {
                  _this.closeSection();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
                });
              }
            }
          }

          document.addEventListener('shopify:section:select', (event) => {
            handlePopupSelect(event);
          });
  
          document.addEventListener('shopify:block:select', (event) => {
            handlePopupSelect(event);
          });

          // Reload the popup and display the overlay when change screen in Shopify admin
          if (data.name != 'popup-age-verification') {
            window.addEventListener('resize', (event)=> {
              handlePopupSelect(event, xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)));
            })
          }
        }

        localStorage.setItem('promotion-popup', '[]');
  
        this.$watch('show', (value) => {
          if (!value) {
            this.close();
          }
        });
      },
      load() {
        // Optimize the JavaScript for popup loading.
        if (window.location.pathname === '/challenge') return;

        const _this= this;
        if (Shopify.designMode) {
          _this.open();
        } else {
          if (data.name == 'popup-promotion' && !this.handleSchedule() && data.showCountdown) return;

          if (data.name == 'popup-promotion' && document.querySelector("#x-age-popup") && xParseJSON(localStorage.getItem('popup-age-verification')) == null) {
            document.addEventListener("close-age-verification", () => {
              this.triggerIntent();
              if (data.trigger_intent == 'delay') {
                setTimeout(() => {
                  _this.open();
                }, data.delays * 1000);
              }
            })
            return;
          }
          
          this.triggerIntent();
        }
      },
      open() {
        if (!Shopify.designMode && this.isExpireSave() && !this.show) return;

        var _this = this;
        if (data.name == 'popup-age-verification') {
          if (this.isExpireSave() && !Shopify.designMode && !data.show_popup) return;

          requestAnimationFrame(() => {
            document.body.classList.add("overflow-hidden");
            Alpine.store('xPopup').open = true;
          });
        }

        // Show minimal popup when
        // 1. "Show minimal" is enabled for desktop, default style is set to "minimal", and the window width is >= 768
        // 2. "Show minimal" is enabled for mobile, default mobile style is set to "minimal", and the window width is < 768
        if ((data.showMinimal && data.default_style == "minimal" && window.innerWidth >= 768) 
          || (data.showMinimalMobile && data.default_style_mobile == "minimal" && window.innerWidth < 768)) {
          _this.showMinimal = true;
          _this.show = false;
          if (Shopify.designMode) {
            localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
            _this.removeOverlay();
          }
        } else {
          // Show full popup
          if (data.showOnMobile && window.innerWidth < 768 || window.innerWidth >= 768) {
            // Show a full popup the first time a customer accesses the site. If the customer closes the full popup, display a minimal popup for the rest of the session.
            if (localStorage.getItem('current-' + data.sectionId) == 'minimal') {
              _this.showMinimal = true;
              _this.show = false;
              _this.removeOverlay();
            } else {
              _this.show = true;
              _this.showMinimal = false;
              _this.setOverlay();
              if (!Shopify.designMode) {
                _this.saveDisplayedPopup();
              }
            }
          } else {
            // Show nothing when screen width is < 768 and "Show popup on mobile" is disabled.
            _this.removeOverlay();
          }
        }
      },
      close() {
        if (data.name == 'popup-age-verification') {
          this.show = false;
          requestAnimationFrame(() => {
            document.body.classList.remove("overflow-hidden");
            Alpine.store('xPopup').close();
          });
          document.dispatchEvent(new Event('close-age-verification'));
          if (!this.isExpireSave()) {
            this.setExpire()
          }
          this.removeDisplayedPopup();
          return;
        }
        var _this = this;
        if (Shopify.designMode) {
          requestAnimationFrame(() => {
            setTimeout(() => {
              _this.showMinimal = true;
            }, 300);
          });
        } else {
          this.removeDisplayedPopup();
          if ((data.showMinimal && window.innerWidth >= 768) || (data.showMinimalMobile && window.innerWidth < 768)) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                _this.showMinimal = true;
              }, 300);
              // Save data to storage when the full popup is closed (the full popup only shows on the first access to the site)
              localStorage.setItem('current-' + data.sectionId, 'minimal');
            });
          } else {
            if (!this.isExpireSave()) {
              this.setExpire()
            }
          }
        }
        requestAnimationFrame(() => {
          setTimeout(() => {
            _this.show = false;
            _this.removeOverlay();
          }, 300);
        });
      },
      triggerIntent() {     
        var _this = this;
        switch (data.trigger_intent) {
          case "exit":
            document.addEventListener('mouseleave', (event) => {
              if (event.clientY <= 0 || event.clientX <= 0 || event.clientY >= window.innerHeight || event.clientX >= window.innerWidth) {
                _this.open();
              }
            });
            break;
          case "copy_to_clipboard":
            document.addEventListener('copy', () => {
              _this.open();
            });
            break;
          case "scroll":
            window.addEventListener('scroll', () => {
              const scrollPosition = window.scrollY + window.innerHeight;
              const documentHeight = document.documentElement.scrollHeight;
              if (scrollPosition >= documentHeight * data.scroll_height) { // Enable when scroll to scroll_height percent page
                _this.open();
              }
            });
            break;
          case "delay":
            setTimeout(() => {
              _this.open();
            }, data.delays * 1000);
            break;
          case "click":
            document.addEventListener('click', (event) => {
              if (event.target.matches(data.trigger_selector)) {
                _this.open();
              }
            });
            break;
          case "hover":
            document.addEventListener('mouseenter', (event) => {
              if (event.target.matches(data.trigger_selector)) {
                _this.open();
              }
            });
            break;
          case "focus":
            document.addEventListener('focus', (event) => {
              if (event.target.matches(data.trigger_selector)) {
                _this.open();
              }
            });
            break;
          case "load":
            _this.open();
            break;
        }
      },
      closeSection() {
        this.show = false;
        this.showMinimal = false;
        this.removeOverlay();
      },
      setExpire() {
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + this.delayDays);
        localStorage.setItem(data.name + '-' + data.sectionId + '-expire', expireDate.toISOString());
      },
      isExpireSave() {
        const expireDate = localStorage.getItem(data.name + '-' + data.sectionId + '-expire');
        if (!expireDate) return false;
        return new Date(expireDate) > new Date();
      },
      handleSchedule() {
        if (!data.schedule_enabled) return false;
        const now = new Date();
        const startDate = new Date(data.start_year, data.start_month - 1, data.start_day, data.start_hour, data.start_minute);
        const endDate = new Date(data.end_year, data.end_month - 1, data.end_day, data.end_hour, data.end_minute);
        return now >= startDate && now <= endDate;
      },
      clickMinimal() {
        this.showMinimal = false;
        this.show = true;
        this.setOverlay();
        if (!Shopify.designMode) {
          this.saveDisplayedPopup();
        }
      },
      setOverlay() {
        if (data.overlay) {
          document.body.classList.add("overflow-hidden");
        }
      },
      removeOverlay() {
        if (data.overlay) {
          document.body.classList.remove("overflow-hidden");
        }
      },
      closeMinimal() {
        this.showMinimal = false;
        if (!this.isExpireSave()) {
          this.setExpire()
        }
      },
      saveDisplayedPopup() {
        const displayedPopups = JSON.parse(localStorage.getItem('promotion-popup') || '[]');
        if (!displayedPopups.includes(data.sectionId)) {
          displayedPopups.push(data.sectionId);
          localStorage.setItem('promotion-popup', JSON.stringify(displayedPopups));
        }
      },
      removeDisplayedPopup() {
        const displayedPopups = JSON.parse(localStorage.getItem('promotion-popup') || '[]');
        const index = displayedPopups.indexOf(data.sectionId);
        if (index > -1) {
          displayedPopups.splice(index, 1);
          localStorage.setItem('promotion-popup', JSON.stringify(displayedPopups));
        }
      }
    }));
  } else {
    // Fallback: register when Alpine is available
    document.addEventListener('alpine:init', () => { 
      Alpine.data('xPopups', (data) => ({
        enable: false,
        showMinimal: false,
        show: Shopify.designMode ? ( localStorage.getItem(data.name + '-' + data.sectionId)? xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)) : true ) : false,
        delayDays: data.delayDays ? data.delayDays : 0,
        t: '',
        copySuccess: false,
        init() {
          if (Shopify.designMode) {
            var _this = this;
            const handlePopupSelect = (event, isResize = null) => {
              if (event.detail && event.detail.sectionId.includes(data.sectionId) || isResize) {
                if (window.Alpine) {
                  _this.open();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
                } else {
                  document.addEventListener('alpine:initialized', () => {
                    _this.open();
                    localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
                  });
                }
              } else {
                if (window.Alpine) {
                  _this.closeSection();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
                } else {
                  document.addEventListener('alpine:initialized', () => {
                    _this.closeSection();
                    localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
                  });
                }
              }
            }

            document.addEventListener('shopify:section:select', (event) => {
              handlePopupSelect(event);
            });
  
            document.addEventListener('shopify:block:select', (event) => {
              handlePopupSelect(event);
            });

            // Reload the popup and display the overlay when change screen in Shopify admin
            if (data.name != 'popup-age-verification') {
              window.addEventListener('resize', (event)=> {
                handlePopupSelect(event, xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)));
              })
            }
          }

          localStorage.setItem('promotion-popup', '[]');
  
          this.$watch('show', (value) => {
            if (!value) {
              this.close();
            }
          });
        },
        load() {
          // Optimize the JavaScript for popup loading.
          if (window.location.pathname === '/challenge') return;

          const _this= this;
          if (Shopify.designMode) {
            _this.open();
          } else {
            if (data.name == 'popup-promotion' && !this.handleSchedule() && data.showCountdown) return;

            if (data.name == 'popup-promotion' && document.querySelector("#x-age-popup") && xParseJSON(localStorage.getItem('popup-age-verification')) == null) {
              document.addEventListener("close-age-verification", () => {
                this.triggerIntent();
                if (data.trigger_intent == 'delay') {
                  setTimeout(() => {
                    _this.open();
                  }, data.delays * 1000);
                }
              })
              return;
            }
            
            this.triggerIntent();
          }
        },
        open() {
          if (!Shopify.designMode && this.isExpireSave() && !this.show) return;

          var _this = this;
          if (data.name == 'popup-age-verification') {
            if (this.isExpireSave() && !Shopify.designMode && !data.show_popup) return;

            requestAnimationFrame(() => {
              document.body.classList.add("overflow-hidden");
              Alpine.store('xPopup').open = true;
            });
          }

          // Show minimal popup when
          // 1. "Show minimal" is enabled for desktop, default style is set to "minimal", and the window width is >= 768
          // 2. "Show minimal" is enabled for mobile, default mobile style is set to "minimal", and the window width is < 768
          if ((data.showMinimal && data.default_style == "minimal" && window.innerWidth >= 768) 
            || (data.showMinimalMobile && data.default_style_mobile == "minimal" && window.innerWidth < 768)) {
            _this.showMinimal = true;
            _this.show = false;
            if (Shopify.designMode) {
              localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
              _this.removeOverlay();
            }
          } else {
            // Show full popup
            if (data.showOnMobile && window.innerWidth < 768 || window.innerWidth >= 768) {
              // Show a full popup the first time a customer accesses the site. If the customer closes the full popup, display a minimal popup for the rest of the session.
              if (localStorage.getItem('current-' + data.sectionId) == 'minimal') {
                _this.showMinimal = true;
                _this.show = false;
                _this.removeOverlay();
              } else {
                _this.show = true;
                _this.showMinimal = false;
                _this.setOverlay();
                if (!Shopify.designMode) {
                  _this.saveDisplayedPopup();
                }
              }
            } else {
              // Show nothing when screen width is < 768 and "Show popup on mobile" is disabled.
              _this.removeOverlay();
            }
          }
        },
        close() {
          if (data.name == 'popup-age-verification') {
            this.show = false;
            requestAnimationFrame(() => {
              document.body.classList.remove("overflow-hidden");
              Alpine.store('xPopup').close();
            });
            document.dispatchEvent(new Event('close-age-verification'));
            if (!this.isExpireSave()) {
              this.setExpire()
            }
            this.removeDisplayedPopup();
            return;
          }
          var _this = this;
          if (Shopify.designMode) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                _this.showMinimal = true;
              }, 300);
            });
          } else {
            this.removeDisplayedPopup();
            if ((data.showMinimal && window.innerWidth >= 768) || (data.showMinimalMobile && window.innerWidth < 768)) {
              requestAnimationFrame(() => {
                setTimeout(() => {
                  _this.showMinimal = true;
                }, 300);
                // Save data to storage when the full popup is closed (the full popup only shows on the first access to the site)
                localStorage.setItem('current-' + data.sectionId, 'minimal');
              });
            } else {
              if (!this.isExpireSave()) {
                this.setExpire()
              }
            }
          }
          requestAnimationFrame(() => {
            setTimeout(() => {
              _this.show = false;
              _this.removeOverlay();
            }, 300);
          });
        },
        triggerIntent() {     
          var _this = this;
          switch (data.trigger_intent) {
            case "exit":
              document.addEventListener('mouseleave', (event) => {
                if (event.clientY <= 0 || event.clientX <= 0 || event.clientY >= window.innerHeight || event.clientX >= window.innerWidth) {
                  _this.open();
                }
              });
              break;
            case "copy_to_clipboard":
              document.addEventListener('copy', () => {
                _this.open();
              });
              break;
            case "scroll":
              window.addEventListener('scroll', () => {
                const scrollPosition = window.scrollY + window.innerHeight;
                const documentHeight = document.documentElement.scrollHeight;
                if (scrollPosition >= documentHeight * data.scroll_height) { // Enable when scroll to scroll_height percent page
                  _this.open();
                }
              });
              break;
            case "delay":
              setTimeout(() => {
                _this.open();
              }, data.delays * 1000);
              break;
            case "click":
              document.addEventListener('click', (event) => {
                if (event.target.matches(data.trigger_selector)) {
                  _this.open();
                }
              });
              break;
            case "hover":
              document.addEventListener('mouseenter', (event) => {
                if (event.target.matches(data.trigger_selector)) {
                  _this.open();
                }
              });
              break;
            case "focus":
              document.addEventListener('focus', (event) => {
                if (event.target.matches(data.trigger_selector)) {
                  _this.open();
                }
              });
              break;
            case "load":
              _this.open();
              break;
          }
        },
        closeSection() {
          this.show = false;
          this.showMinimal = false;
          this.removeOverlay();
        },
        setExpire() {
          const expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + this.delayDays);
          localStorage.setItem(data.name + '-' + data.sectionId + '-expire', expireDate.toISOString());
        },
        isExpireSave() {
          const expireDate = localStorage.getItem(data.name + '-' + data.sectionId + '-expire');
          if (!expireDate) return false;
          return new Date(expireDate) > new Date();
        },
        handleSchedule() {
          if (!data.schedule_enabled) return false;
          const now = new Date();
          const startDate = new Date(data.start_year, data.start_month - 1, data.start_day, data.start_hour, data.start_minute);
          const endDate = new Date(data.end_year, data.end_month - 1, data.end_day, data.end_hour, data.end_minute);
          return now >= startDate && now <= endDate;
        },
        clickMinimal() {
          this.showMinimal = false;
          this.show = true;
          this.setOverlay();
          if (!Shopify.designMode) {
            this.saveDisplayedPopup();
          }
        },
        setOverlay() {
          if (data.overlay) {
            document.body.classList.add("overflow-hidden");
          }
        },
        removeOverlay() {
          if (data.overlay) {
            document.body.classList.remove("overflow-hidden");
          }
        },
        closeMinimal() {
          this.showMinimal = false;
          if (!this.isExpireSave()) {
            this.setExpire()
          }
        },
        saveDisplayedPopup() {
          const displayedPopups = JSON.parse(localStorage.getItem('promotion-popup') || '[]');
          if (!displayedPopups.includes(data.sectionId)) {
            displayedPopups.push(data.sectionId);
            localStorage.setItem('promotion-popup', JSON.stringify(displayedPopups));
          }
        },
        removeDisplayedPopup() {
          const displayedPopups = JSON.parse(localStorage.getItem('promotion-popup') || '[]');
          const index = displayedPopups.indexOf(data.sectionId);
          if (index > -1) {
            displayedPopups.splice(index, 1);
            localStorage.setItem('promotion-popup', JSON.stringify(displayedPopups));
          }
        }
      }));
    });
  }
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => { 
      Alpine.data('xPopups', (data) => ({
        enable: false,
        showMinimal: false,
        show: Shopify.designMode ? ( localStorage.getItem(data.name + '-' + data.sectionId)? xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)) : true ) : false,
        delayDays: data.delayDays ? data.delayDays : 0,
        t: '',
        copySuccess: false,
        init() {
          if (Shopify.designMode) {
            var _this = this;
            const handlePopupSelect = (event, isResize = null) => {
              if (event.detail && event.detail.sectionId.includes(data.sectionId) || isResize) {
                if (window.Alpine) {
                  _this.open();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
                } else {
                  document.addEventListener('alpine:initialized', () => {
                    _this.open();
                    localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
                  });
                }
              } else {
                if (window.Alpine) {
                  _this.closeSection();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
                } else {
                  document.addEventListener('alpine:initialized', () => {
                    _this.closeSection();
                    localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
                  });
                }
              }
            }

            document.addEventListener('shopify:section:select', (event) => {
              handlePopupSelect(event);
            });
  
            document.addEventListener('shopify:block:select', (event) => {
              handlePopupSelect(event);
            });

            // Reload the popup and display the overlay when change screen in Shopify admin
            if (data.name != 'popup-age-verification') {
              window.addEventListener('resize', (event)=> {
                handlePopupSelect(event, xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)));
              })
            }
          }

          localStorage.setItem('promotion-popup', '[]');
  
          this.$watch('show', (value) => {
            if (!value) {
              this.close();
            }
          });
        },
        load() {
          // Optimize the JavaScript for popup loading.
          if (window.location.pathname === '/challenge') return;

          const _this= this;
          if (Shopify.designMode) {
            _this.open();
          } else {
            if (data.name == 'popup-promotion' && !this.handleSchedule() && data.showCountdown) return;

            if (data.name == 'popup-promotion' && document.querySelector("#x-age-popup") && xParseJSON(localStorage.getItem('popup-age-verification')) == null) {
              document.addEventListener("close-age-verification", () => {
                this.triggerIntent();
                if (data.trigger_intent == 'delay') {
                  setTimeout(() => {
                    _this.open();
                  }, data.delays * 1000);
                }
              })
              return;
            }
            
            this.triggerIntent();
          }
        },
        open() {
          if (!Shopify.designMode && this.isExpireSave() && !this.show) return;

          var _this = this;
          if (data.name == 'popup-age-verification') {
            if (this.isExpireSave() && !Shopify.designMode && !data.show_popup) return;

            requestAnimationFrame(() => {
              document.body.classList.add("overflow-hidden");
              Alpine.store('xPopup').open = true;
            });
          }

          // Show minimal popup when
          // 1. "Show minimal" is enabled for desktop, default style is set to "minimal", and the window width is >= 768
          // 2. "Show minimal" is enabled for mobile, default mobile style is set to "minimal", and the window width is < 768
          if ((data.showMinimal && data.default_style == "minimal" && window.innerWidth >= 768) 
            || (data.showMinimalMobile && data.default_style_mobile == "minimal" && window.innerWidth < 768)) {
            _this.showMinimal = true;
            _this.show = false;
            if (Shopify.designMode) {
              localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
              _this.removeOverlay();
            }
          } else {
            // Show full popup
            if (data.showOnMobile && window.innerWidth < 768 || window.innerWidth >= 768) {
              // Show a full popup the first time a customer accesses the site. If the customer closes the full popup, display a minimal popup for the rest of the session.
              if (localStorage.getItem('current-' + data.sectionId) == 'minimal') {
                _this.showMinimal = true;
                _this.show = false;
                _this.removeOverlay();
              } else {
                _this.show = true;
                _this.showMinimal = false;
                _this.setOverlay();
                if (!Shopify.designMode) {
                  _this.saveDisplayedPopup();
                }
              }
            } else {
              // Show nothing when screen width is < 768 and "Show popup on mobile" is disabled.
              _this.removeOverlay();
            }
          }
        },
        close() {
          if (data.name == 'popup-age-verification') {
            this.show = false;
            requestAnimationFrame(() => {
              document.body.classList.remove("overflow-hidden");
              Alpine.store('xPopup').close();
            });
            document.dispatchEvent(new Event('close-age-verification'));
            if (!this.isExpireSave()) {
              this.setExpire()
            }
            this.removeDisplayedPopup();
            return;
          }
          var _this = this;
          if (Shopify.designMode) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                _this.showMinimal = true;
              }, 300);
            });
          } else {
            this.removeDisplayedPopup();
            if ((data.showMinimal && window.innerWidth >= 768) || (data.showMinimalMobile && window.innerWidth < 768)) {
              requestAnimationFrame(() => {
                setTimeout(() => {
                  _this.showMinimal = true;
                }, 300);
                // Save data to storage when the full popup is closed (the full popup only shows on the first access to the site)
                localStorage.setItem('current-' + data.sectionId, 'minimal');
              });
            } else {
              if (!this.isExpireSave()) {
                this.setExpire()
              }
            }
          }
          requestAnimationFrame(() => {
            setTimeout(() => {
              _this.show = false;
              _this.removeOverlay();
            }, 300);
          });
        },
        triggerIntent() {     
          var _this = this;
          switch (data.trigger_intent) {
            case "exit":
              document.addEventListener('mouseleave', (event) => {
                if (event.clientY <= 0 || event.clientX <= 0 || event.clientY >= window.innerHeight || event.clientX >= window.innerWidth) {
                  _this.open();
                }
              });
              break;
            case "copy_to_clipboard":
              document.addEventListener('copy', () => {
                _this.open();
              });
              break;
            case "scroll":
              window.addEventListener('scroll', () => {
                const scrollPosition = window.scrollY + window.innerHeight;
                const documentHeight = document.documentElement.scrollHeight;
                if (scrollPosition >= documentHeight * data.scroll_height) { // Enable when scroll to scroll_height percent page
                  _this.open();
                }
              });
              break;
            case "delay":
              setTimeout(() => {
                _this.open();
              }, data.delays * 1000);
              break;
            case "click":
              document.addEventListener('click', (event) => {
                if (event.target.matches(data.trigger_selector)) {
                  _this.open();
                }
              });
              break;
            case "hover":
              document.addEventListener('mouseenter', (event) => {
                if (event.target.matches(data.trigger_selector)) {
                  _this.open();
                }
              });
              break;
            case "focus":
              document.addEventListener('focus', (event) => {
                if (event.target.matches(data.trigger_selector)) {
                  _this.open();
                }
              });
              break;
            case "load":
              _this.open();
              break;
          }
        },
        closeSection() {
          this.show = false;
          this.showMinimal = false;
          this.removeOverlay();
        },
        setExpire() {
          const expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + this.delayDays);
          localStorage.setItem(data.name + '-' + data.sectionId + '-expire', expireDate.toISOString());
        },
        isExpireSave() {
          const expireDate = localStorage.getItem(data.name + '-' + data.sectionId + '-expire');
          if (!expireDate) return false;
          return new Date(expireDate) > new Date();
        },
        handleSchedule() {
          if (!data.schedule_enabled) return false;
          const now = new Date();
          const startDate = new Date(data.start_year, data.start_month - 1, data.start_day, data.start_hour, data.start_minute);
          const endDate = new Date(data.end_year, data.end_month - 1, data.end_day, data.end_hour, data.end_minute);
          return now >= startDate && now <= endDate;
        },
        clickMinimal() {
          this.showMinimal = false;
          this.show = true;
          this.setOverlay();
          if (!Shopify.designMode) {
            this.saveDisplayedPopup();
          }
        },
        setOverlay() {
          if (data.overlay) {
            document.body.classList.add("overflow-hidden");
          }
        },
        removeOverlay() {
          if (data.overlay) {
            document.body.classList.remove("overflow-hidden");
          }
        },
        closeMinimal() {
          this.showMinimal = false;
          if (!this.isExpireSave()) {
            this.setExpire()
          }
        },
        saveDisplayedPopup() {
          const displayedPopups = JSON.parse(localStorage.getItem('promotion-popup') || '[]');
          if (!displayedPopups.includes(data.sectionId)) {
            displayedPopups.push(data.sectionId);
            localStorage.setItem('promotion-popup', JSON.stringify(displayedPopups));
          }
        },
        removeDisplayedPopup() {
          const displayedPopups = JSON.parse(localStorage.getItem('promotion-popup') || '[]');
          const index = displayedPopups.indexOf(data.sectionId);
          if (index > -1) {
            displayedPopups.splice(index, 1);
            localStorage.setItem('promotion-popup', JSON.stringify(displayedPopups));
          }
        }
      }));
    })
  })
}